import { useQueryApi } from 'utils/api'
import { apiPaths, handleError, queryKeys, validateStatus } from './config'

import type { UseQueryOptions } from 'react-query'
import type { CommonResponse } from 'types/api'
import type { PSPegawaiProfile } from 'types/kinerja-ps-pegawai'

type ProfileResponse = CommonResponse<PSPegawaiProfile>

export function useAPIGetPSPegawaiProfile(
  options: UseQueryOptions<ProfileResponse>
) {
  return useQueryApi<ProfileResponse>(apiPaths.profile, {
    queryKey: [queryKeys.API_GET_PROFILE],
    axiosConfig: {
      validateStatus,
    },
    queryConfig: {
      useErrorBoundary: false,
      ...options,
    },
    errorHandlerFn: handleError,
  })
}
